import apiClient from "@repo/ui/lib/apiClient";
import type { ApiResponse } from "@repo/ui/types/apiResponse";
import type { GroupedStations } from "@repo/ui/types/stations";

export const getStations = async (
  tabSessionId?: string | null,
): Promise<GroupedStations | null> => {
  try {
    const response = await apiClient<ApiResponse<GroupedStations>>(
      "/v1/resources/stations?ActiveOnly=true",
      {
        withAuth: true,
        tabSessionId,
      },
    );

    return response?.data ?? null;
  } catch (error) {
    console.error("Failed to fetch stations:", error);
    return null;
  }
};
